import { useState } from 'react';

// material-ui
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';

// assets
import SwapOutlined from '@ant-design/icons/SwapOutlined';

// project imports
import axios from 'utils/axios';
import useAuth from 'hooks/useAuth';
import { BINA_SAKINI } from 'utils/roles';
import { AKTIF_DAIRE_KEY, DAIRELER_KEY } from 'utils/authStorage';

// ==============================|| HEADER - DAİRE DEĞİŞTİR ||============================== //
// Bölüm 8 Uç Durum 10'un login-time gate'i DEĞİL, login SONRASI erişilebilen bir
// basitleştirme (bkz. backend/docs/frontend_scaffold.md). Yalnızca birden fazla
// aktif daire ilişkisi olan bina_sakini için görünür (login response'undaki
// 'daireler' listesi JWTContext.login() içinde localStorage'a yazılmıştı).

export default function DaireDegistir() {
  const { kullaniciTipi } = useAuth();
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  if (kullaniciTipi !== BINA_SAKINI) return null;

  let daireler = [];
  try {
    daireler = JSON.parse(localStorage.getItem(DAIRELER_KEY) || '[]');
  } catch {
    daireler = [];
  }

  if (daireler.length < 2) return null;

  const handleSelect = async (daire) => {
    setError(null);
    try {
      await axios.post('auth/aktif-daire/', { daire_id: daire.id });
      localStorage.setItem(AKTIF_DAIRE_KEY, JSON.stringify(daire));
      setOpen(false);
      window.location.reload();
    } catch {
      setError('Daire seçimi sırasında bir hata oluştu, lütfen tekrar deneyin.');
    }
  };

  return (
    <>
      <Tooltip title="Daire Değiştir">
        <IconButton onClick={() => setOpen(true)} disableRipple color="secondary" sx={{ color: 'text.primary', bgcolor: 'grey.100' }}>
          <SwapOutlined />
        </IconButton>
      </Tooltip>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Daire Değiştir</DialogTitle>
        <DialogContent>
          {error && <Alert severity="error">{error}</Alert>}
          <List disablePadding>
            {daireler.map((daire) => (
              <ListItemButton key={daire.id} divider onClick={() => handleSelect(daire)}>
                <ListItemText primary={daire.aciklama} />
              </ListItemButton>
            ))}
          </List>
        </DialogContent>
      </Dialog>
    </>
  );
}
